export default "__VITE_ASSET__yAXlMphU__"